import React from "react";

const UpdateJoiningInstruction = ({ 
  formData, 
  setFormData, 
  handleChange, 
  handleItemChange, 
  addItem, 
  removeItem, 
  handleSubmit, 
  loading, 
  onCancel,
  error 
}) => {
  return (
    <div className="p-6 max-w-2xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Joining Instruction</h2>

      {loading && <p className="text-blue-500 mb-4">Updating...</p>}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Slug:</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
          />
        </div>

        <div>
          <label className="block mb-1">Icon:</label>
          <input
            type="text"
            name="icon"
            value={formData.icon}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          />
        </div>

        <div>
          <label className="block mb-1">Title:</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
          />
        </div>

        <div>
          <label className="block mb-1">Subtitle:</label>
          <input
            type="text"
            name="subtitle"
            value={formData.subtitle}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="border-t pt-4">
          <div className="flex justify-between items-center mb-2">
            <h3 className="font-medium">Instruction Items</h3>
            <button
              type="button"
              onClick={addItem}
              className="text-sm bg-blue-500 text-white px-2 py-1 rounded"
            >
              Add Item
            </button>
          </div>

          {formData.items.map((item, index) => (
            <div key={item.id || index} className="mb-4 p-3 border rounded">
              <div className="flex justify-between mb-2">
                <span className="font-medium">Item {index + 1}</span>
                {formData.items.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeItem(index)}
                    className="text-red-500 text-sm"
                  >
                    Remove
                  </button>
                )}
              </div>
              
              <div className="mb-2">
                <label className="block mb-1">Icon:</label>
                <input
                  type="text"
                  name="icon"
                  value={item.icon}
                  onChange={(e) => handleItemChange(index, e)}
                  className="w-full p-2 border rounded"
                />
              </div>
              
              <div>
                <label className="block mb-1">Description:</label>
                <textarea
                  name="description"
                  value={item.description}
                  onChange={(e) => handleItemChange(index, e)}
                  className="w-full p-2 border rounded"
                  rows="3"
                  required
                ></textarea>
              </div>
            </div>
          ))}
        </div>

         <div className="flex justify-end space-x-3">
             <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              disabled={loading}
            >
              Cancel
            </button>
           <button
              type="submit"
              className="w-full py-2 px-4 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-400"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Joining Instruction"}
            </button>
        </div>

      
      </form>
    </div>
  );
};

export default UpdateJoiningInstruction;